<div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div>


<div class="container" *ngIf="inquiryData && inquiryData.length > 0">
    <table>
        <thead>
            <tr>
                <th>Sr.no</th>
                <th>Property</th>
                <th>Date</th>
                <th>Address</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let u of inquiryData; let i = index">
                <td>{{i+1}}</td>
                <td><img width="150" height="100" [src]="shared.getImageURL(imageUrl(u.PropertyData.PropertyToPropertyMediaData))"
                    alt="img"></td>
                <td>{{u.PropertyData.posted_at | date}}</td>
                <td>{{u.PropertyData.address}}</td>
                <td>
                    <button type="button" class="btn btn-primary button" data-toggle="modal"
                        data-target="#exampleModalCenter">Edit</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-container>
    <div class="container py-5">
        <div class="row">
          <div class="col-md-12">
            <div class="card text-center">
              <div class="card-body">
                <i class="fas fa-envelope-open-text fa-4x"></i> <!-- FontAwesome icon -->
                <h5 class="card-title mt-3">
                    No Inquiry Received For Your Property
                </h5>
                <p class="card-text">It looks like there haven't been any inquiries for your property yet. Consider updating your listing for better visibility or check back later.</p>
                <a href="/my-property-list" class="btn btn-primary">Update Listing</a>
              </div>
            </div>
          </div>
        </div>
      </div>
</ng-container>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h5 class="modal-title title" id="exampleModalLongTitle">
                    Confirmation
                </h5>
                <button type="button" class="btn btn-primary close" data-dismiss="modal">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="body">
                    <div class="text1">
                        <p>Are you Interested in the Selected Property?</p>
                    </div>
                    <div class="action">
                        <button type="button" class="btn btn-primary button_yes" (click)="onClickyes()">Yes</button>
                        <button type="button" class="btn btn-primary button_no" (click)="onClickno()">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>